import styled from 'styled-components';

/**
 * The design's `.toolbar` — the strip above a table.
 *
 * It replaces the box every list screen drew for itself: a `#f7f8fc` panel
 * with a 12px radius and a 15px side margin, floating inside the card with a
 * 20px gap beneath it. On screens whose search box is commented out — the
 * ticket list is one — that box rendered as a wide empty grey bar with a
 * single button marooned at one end.
 *
 * The toolbar belongs to the card: full bleed, its own padding, one hairline
 * under it, nothing else. Its card must be `flush` with `contentStyle={{
 * padding: 0 }}` so the strip meets the card edge.
 */
export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s3);
  padding: var(--s3) var(--s4);
  border-bottom: 1px solid var(--line);

  /* The search box is the one child that takes the slack. */
  > *:first-child {
    min-width: 0;
  }
`;

/** Everything after this sits at the far end — filters, segmented, actions. */
export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  margin-left: auto;
`;
